import type { SpotlighTargetName } from '../tour';

/**
 * Spotlight target names used for onboarding tour popovers.
 * Kept in a separate file to avoid pulling in the full ExtensionTopBarLayout
 * import chain (which includes OpenSidepanelButton → conversation-assistant-store).
 */
export const WHATS_NEW_MENU_ITEM_SPOTLIGHT_TARGET = 'whats-new-menu-item' as SpotlighTargetName;
